<!-- <app-stroke-firma *ngIf="isFirma"></app-stroke-firma> -->
<app-icono-carga *ngIf="isLoading" message="Saliendo..." />
<bc-header [headerType]="'bc-header-wrapper'" *ngIf="hiddenNav">
  <bc-logo  size="220px"  name="bancolombia-horizontal" [ariaHidden]="false" alt="logo"></bc-logo>
	<div class="contx">
    <button (click)="abrirModal()">
      <bc-icon
        id="icono-salir"
        class="loli"
        name="quit"
        aria-hidden="true"
        aria-label="Salir"
      >
      </bc-icon>
    </button>
	</div>
</bc-header>

<app-modal-salir *ngIf="hiddenNav" [open]="openN" (closeModal)="openN=false"></app-modal-salir>
